import { RedoTextInput } from "../../../arbiter-components/input/redo-text-input";
import { Flex } from "../../../flex";

export function DynamicRangePercentageField({
  min,
  setMin,
  max,
  setMax,
}: {
  min: number | undefined;
  setMin: (value: number | undefined) => void;
  max: number | undefined;
  setMax: (value: number | undefined) => void;
}) {
  return (
    <Flex align="center" gap="md">
      <RedoTextInput
        inputTypeHint="number"
        label="Min percentage"
        placeholder="0"
        setValue={(value) => {
          setMin(value ? Number(value) : undefined);
        }}
        value={min?.toString() ?? ""}
      />
      <RedoTextInput
        inputTypeHint="number"
        label="Max percentage"
        placeholder="100"
        setValue={(value) => {
          setMax(value ? Number(value) : undefined);
        }}
        value={max?.toString() ?? ""}
      />
    </Flex>
  );
}
